import { render, staticRenderFns } from "./TextAreaWithLabel.vue?vue&type=template&id=5b310412&"
import script from "./TextAreaWithLabel.vue?vue&type=script&lang=js&"
export * from "./TextAreaWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaWithLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports